import { withTheme } from "styled-components";
import DefaultTable, {
  ActionButtons,
  Filter,
  Line,
} from "../../../ui-library/CustomTable/DefaultTable";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import AccountStatus from "../../AccountStatus/AccountStatus";
import CustomDropdown from "../../../ui-library/CustomDropdown/CustomDropdown";
import PrimaryButton from "../../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import { UserStatus } from "../../AccountStatus/AccountStatus.constants";
import history from "../../../../modules/history";
import TableDropDown from "../../../ui-library/TableDropDown/TableDropDown";

const ParticipantTable = (props) => {
  const {
    getData,
    searchedParams,
    totalitems,
    participants,
    unlockAccount,
    unblockAccount,
    blockAccount,
    changeStudyStatus,
    generateTemporaryPassword,
    openStudyStatusHistory,
    addParticipant,
    canViewParticipantPage,
    canCreateParticipant,
    canEditParticipant,
    canViewParticipantTemporaryPassword,
    canUnLockParticipant,
    canChangeStudyStatus,
    canViewStudyStatus,
    canGenerateReport,
    openEditParticipantModal,
    canUnblockParticipant,
    showPersonalData,
    openGenerateReportOptions,
    canViewPersonalData,
    canViewMealLog,
    loading,
  } = props;

  const { t } = useTranslation();

  const defaultProps = {
    headers: [
      { label: t("appText.participantTable.site") },
      { label: t("appText.participantID") },
      { label: t("appText.participantTable.studyStatus") },
      { label: t("appText.participantTable.accountStatus") },
      { label: t("appText.options") },
    ],
    hasSearch: true,
    haspagesizefilter: true,
    haspagination: true,
    searchedParams,
    totalitems,
    loading,
    getData,
  };

  const changeFilterBy = (filter) => {
    const params = {
      ...searchedParams,
      page: 0,
      filter: filter.id,
    };
    getData(params);
  };

  const getDropDownItems = (userParticipant) => {
    const dropDownMenuItems = {
      VIEW_PARTICIPANT: {
        text: t("appText.participantTable.viewParticipant"),
        callBack: (participant) => {
          history.push(`/participant/${participant?.participantId}`);
        },
        id: 1,
        isVisible: canViewParticipantPage,
      },
      VIEW_PARTICIPANT_DIET_DIARY: {
        text: t("appText.participantTable.viewParticipantDietDiary"),
        callBack: (participant) => {
          history.push(`/stats/${participant?.participantId}`);
        },
        id: 4,
        isVisible: canViewMealLog,
      },
      GENERATE_TEMP_PASSWORD: {
        text: t("appText.participantTable.generatePassword"),
        callBack: (participant) => generateTemporaryPassword(participant),
        id: 2,
        isVisible: canViewParticipantTemporaryPassword,
      },
      UNLOCK_ACCOUNT: {
        text: t("appText.participantTable.unlockAccount"),
        callBack: (participant) => unlockAccount(participant),
        id: 3,
        isDisabled: userParticipant.status !== UserStatus.LOCKED.id,
        isVisible: canUnLockParticipant,
      },
      CHANGE_STUTDY_STATUS: {
        text: t("appText.participantTable.changeStudyStatus"),
        callBack: (participant) => changeStudyStatus(participant),
        id: 5,
        isVisible: canChangeStudyStatus,
      },
      STUDY_STATUS_HISTORY: {
        text: t("appText.participantTable.studyStatusHistory"),
        callBack: (participant) => openStudyStatusHistory(participant),
        id: 6,
        isVisible: canViewStudyStatus,
      },
      EDIT_PARTICIPANT: {
        text: t("appText.participantTable.editParticipant"),
        callBack: (participant) => openEditParticipantModal(participant),
        id: 7,
        isVisible: canEditParticipant,
      },
      UNBLOCK_USER: {
        text: t("appText.participantTable.unblockUser"),
        callBack: (participant) => unblockAccount(participant),
        id: 8,
        isVisible:
          canUnblockParticipant &&
          userParticipant.status === UserStatus.BLOCKED.id,
      },
      BLOCK_USER: {
        text: t("appText.participantTable.blockUser"),
        callBack: (participant) => blockAccount(participant),
        id: 9,
        isVisible:
          canUnblockParticipant &&
          (userParticipant.status === UserStatus.ACTIVE.id ||
            userParticipant.status === UserStatus.INVITED.id),
      },
      VIEW_PERSONAL_DATA: {
        text: t("appText.participantTable.viewPersonalData"),
        callBack: (participant) => showPersonalData(participant),
        id: 10,
        isVisible: canViewPersonalData,
      },
      GENERATE_REPORT: {
        id: 11,
        text: "Generate Report",
        callBack: (participant) => openGenerateReportOptions(participant),
        isVisible: canGenerateReport,
      },
    };

    return Object.values(dropDownMenuItems);
  };

  return (
    <DefaultTable {...defaultProps}>
      <Filter>
        {t("appText.participantTable.accountStatus")}
        <CustomDropdown
          className="ml-2"
          placeholder={UserStatus.ALL.value}
          values={Object.values(UserStatus).filter(
            (item) =>
              item.value.toLowerCase() !==
              UserStatus.INVITED.value.toLowerCase()
          )}
          onChange={(e) => changeFilterBy(e)}
        />
      </Filter>
      <ActionButtons>
        {canCreateParticipant && (
          <PrimaryButton
            data-testid="add-participant-btn"
            className="btn btn-accent btn-sm mr-2"
            onClick={addParticipant}
          >
            {t("appText.participantTable.addParticipant")}
          </PrimaryButton>
        )}
      </ActionButtons>
      {participants?.map((participant, index) => (
        <Line key={index}>
          <span>{participant.site}</span>
          <span>{participant.userName}</span>
          <span>{participant.studyStatus}</span>
          <AccountStatus>{participant.status}</AccountStatus>
          <TableDropDown>
            {getDropDownItems(participant)
              .filter((dropDownItem) => dropDownItem.isVisible)
              .map((item, index) => (
                <Dropdown.Item
                  key={index}
                  bsPrefix="dropdown-item"
                  disabled={item.isDisabled}
                  onSelect={() => item.callBack(participant)}
                >
                  {item.text}
                </Dropdown.Item>
              ))}
          </TableDropDown>
        </Line>
      ))}
    </DefaultTable>
  );
};

export default withTheme(ParticipantTable);
